const NominalBalanceSheet = {
  type: 'NominalBalanceSheet',
  title: 'Balance Sheet',
  formTitle: 'Balance Sheet',
  formUrl: '/Nominal/BalanceSheet/Details',
  workspaceUrl: '/menu/Nominal',
  screenReference: 'NOMINAL_BALANCESHEET',
  operations: 0,
};

export default NominalBalanceSheet;
